<template>
  <div class="check">
    <el-alert
      v-if="tip"
      :title="tip"
      type="warning"
      :closable="false"
      show-icon
      class="tip-alert"
    />
    <p>{{ $t('order.morePds.pdfLink') }}<span class="link" @click="handleToFile">{{ morePdfs }}</span></p>
    <div class="check-btn">
      <el-button type="primary" @click="handleSure" size='small'>{{ $t('order.morePds.confirmBtn') }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    morePdfs: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      
    }
  },
  methods: {
    handleSure(){
      this.$emit('closeMorePds')
    },
    handleToFile(){
      this.$emit('closeMorePds')
      window.open(this.morePdfs, '_blank');
    }
  }
}
</script>
<style lang="scss" scoped>
  .check{
    font-size: 14px;
    p{
      font-size: 14px;
      line-height: 16px;
    }
  }
  .tip-alert{
    margin-bottom: 12px;
  }
  .check-btn{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px 0;
  }
  .link{
    color: #409EFF;
    cursor: pointer;
  }
</style>